import { minValue, maxValue, numeric, required } from 'vuelidate/lib/validators'

// const regexCodigo = value => {
//   if (typeof value === 'undefined' || value === null || value === '') {
//     return true
//   }
//   return (
//     /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]).){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$|^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]).)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9])$/.test(value)
//   )
// }


export const validateData = {
  form: {
    Port: { numeric, required, minValue: minValue(5000), maxValue: maxValue(65535) },
  },
}

export const validateComputed = {
  PortErrors() {
    const errors = []
    if (!this.$v.form.Port.$dirty) return errors
    !this.$v.form.Port.required && errors.push('Campo obrigatório.')
    !this.$v.form.Port.numeric && errors.push('Insira um valor numérico.')
    !this.$v.form.Port.minValue && errors.push('Valor mínimo: 5000.')
    !this.$v.form.Port.maxValue && errors.push('Valor máximo: 65535.')
    return errors
  },
}
